// Mock data for VK Tours website

export const destinations = [
  { id: 1, name: 'India', packages: 22, image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&h=600&fit=crop' },
  { id: 2, name: 'Singapore', packages: 8, image: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=800&h=600&fit=crop' },
  { id: 3, name: 'Malaysia', packages: 6, image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=800&h=600&fit=crop' },
  { id: 4, name: 'Dubai', packages: 10, image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800&h=600&fit=crop' },
  { id: 5, name: 'Maldives', packages: 7, image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&h=600&fit=crop' },
  { id: 6, name: 'Sri Lanka', packages: 5, image: 'https://images.unsplash.com/photo-1552046122-03184de85e08?w=800&h=600&fit=crop' },
  { id: 7, name: 'Nepal', packages: 4, image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop' },
  { id: 8, name: 'Bhutan', packages: 3, image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&h=600&fit=crop' },
  { id: 9, name: 'Vietnam', packages: 6, image: 'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=800&h=600&fit=crop' },
  { id: 10, name: 'Indonesia', packages: 8, image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&h=600&fit=crop' },
  { id: 11, name: 'Australia', packages: 9, image: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=800&h=600&fit=crop' },
  { id: 12, name: 'Mauritius', packages: 4, image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&h=600&fit=crop' },
  { id: 13, name: 'USA', packages: 12, image: 'https://images.unsplash.com/photo-1485738422979-f5c462d49f74?w=800&h=600&fit=crop' },
  { id: 14, name: 'Europe', packages: 15, image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800&h=600&fit=crop' },
  { id: 15, name: 'Russia', packages: 5, image: 'https://images.unsplash.com/photo-1513326738677-b964603b136d?w=800&h=600&fit=crop' }
];

export const cruises = [
  {
    id: 1,
    title: 'Mediterranean Explorer',
    destination: 'Europe',
    duration: '7 Days',
    route: 'Barcelona • Rome • Naples • Florence',
    price: '₹1,25,000',
    image: 'https://images.unsplash.com/photo-1578922746999-72c0cf6c4d05?w=800&h=600&fit=crop',
    rating: 4.8
  },
  {
    id: 2,
    title: 'Caribbean Paradise',
    destination: 'Caribbean',
    duration: '10 Days',
    route: 'Miami • Bahamas • Jamaica • Cozumel',
    price: '₹1,85,000',
    image: 'https://images.unsplash.com/photo-1562516155-e0c1ee44059b?w=800&h=600&fit=crop',
    rating: 4.9
  },
  {
    id: 3,
    title: 'Asian Coastal Journey',
    destination: 'Asia',
    duration: '12 Days',
    route: 'Singapore • Thailand • Vietnam • Hong Kong',
    price: '₹1,65,000',
    image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=800&h=600&fit=crop',
    rating: 4.7
  }
];

export const pilgrimages = [
  {
    id: 1,
    title: 'Char Dham Yatra',
    destination: 'India',
    location: 'Uttarakhand',
    duration: '12 Days',
    route: 'Yamunotri • Gangotri • Kedarnath • Badrinath',
    price: '₹58,000',
    image: 'https://images.unsplash.com/photo-1591798699512-48f9a6c82215?w=800&h=600&fit=crop',
    rating: 4.9,
    tag: 'Most Sacred'
  },
  {
    id: 2,
    title: 'Kashi Vishwanath Darshan',
    destination: 'India',
    location: 'Varanasi',
    duration: '5 Days',
    route: 'Kashi Vishwanath • Ganga Aarti • Sarnath • Vindhyachal',
    price: '₹22,000',
    image: 'https://images.unsplash.com/photo-1561361513-2d000a50f0dc?w=800&h=600&fit=crop',
    rating: 4.8
  },
  {
    id: 3,
    title: 'Tirupati Balaji Darshan',
    destination: 'India',
    location: 'Andhra Pradesh',
    duration: '4 Days',
    route: 'Tirupati Temple • Kalahasti • Kanipakam • Srikalahasti',
    price: '₹18,000',
    image: 'https://images.unsplash.com/photo-1548013146-72479768bada?w=800&h=600&fit=crop',
    rating: 4.7
  },
  {
    id: 4,
    title: 'Dwarka Somnath Yatra',
    destination: 'India',
    location: 'Gujarat',
    duration: '6 Days',
    route: 'Dwarka • Somnath • Nageshwar • Bet Dwarka',
    price: '₹28,000',
    image: 'https://images.unsplash.com/photo-1605649487212-1a5c60c2d473?w=800&h=600&fit=crop',
    rating: 4.6
  },
  {
    id: 5,
    title: 'Mathura Vrindavan Yatra',
    destination: 'India',
    location: 'Uttar Pradesh',
    duration: '5 Days',
    route: 'Krishna Janmabhoomi • Banke Bihari • Govind Dev • Radha Raman',
    price: '₹24,000',
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&h=600&fit=crop',
    rating: 4.8
  },
  {
    id: 6,
    title: 'Shirdi Sai Baba Darshan',
    destination: 'India',
    location: 'Maharashtra',
    duration: '3 Days',
    route: 'Shirdi Temple • Dwarkamai • Chavadi • Shani Shingnapur',
    price: '₹15,000',
    image: 'https://images.unsplash.com/photo-1582741746505-f11b4c5c98a8?w=800&h=600&fit=crop',
    rating: 4.9
  }
];

export const packages = [
  {
    id: 1,
    title: 'Golden Triangle India',
    destination: 'India',
    duration: '7 Days',
    route: 'Delhi • Agra • Jaipur • Taj Mahal',
    price: '₹25,000',
    image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800&h=600&fit=crop',
    rating: 4.8
  },
  {
    id: 2,
    title: 'Maldives Paradise',
    destination: 'Maldives',
    duration: '6 Days',
    route: 'Overwater Villas • Coral Reefs • Water Sports • Spa Treatments',
    price: '₹85,000',
    image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?w=800&h=600&fit=crop',
    rating: 4.9
  },
  {
    id: 3,
    title: 'Sri Lanka Cultural Tour',
    destination: 'Sri Lanka',
    duration: '8 Days',
    route: 'Kandy • Sigiriya • Galle Fort • Tea Plantations',
    price: '₹42,000',
    image: 'https://images.unsplash.com/photo-1552046122-03184de85e08?w=800&h=600&fit=crop',
    rating: 4.7
  },
  {
    id: 4,
    title: 'Nepal Himalayan Adventure',
    destination: 'Nepal',
    duration: '10 Days',
    route: 'Kathmandu • Pokhara • Everest Base Camp • Annapurna',
    price: '₹55,000',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
    rating: 4.6
  },
  {
    id: 5,
    title: 'Bhutan Dragon Kingdom',
    destination: 'Bhutan',
    duration: '7 Days',
    route: 'Thimphu • Paro • Tigers Nest • Punakha Dzong',
    price: '₹75,000',
    image: 'https://images.unsplash.com/photo-1609137144813-7d9921338f24?w=800&h=600&fit=crop',
    rating: 4.8
  },
  {
    id: 6,
    title: 'Vietnam Discovery',
    destination: 'Vietnam',
    duration: '9 Days',
    route: 'Hanoi • Halong Bay • Ho Chi Minh • Mekong Delta',
    price: '₹48,000',
    image: 'https://images.unsplash.com/photo-1559592413-7cec4d0cae2b?w=800&h=600&fit=crop',
    rating: 4.7
  },
  {
    id: 7,
    title: 'Indonesia Island Hopping',
    destination: 'Indonesia',
    duration: '12 Days',
    route: 'Bali • Jakarta • Yogyakarta • Komodo Island',
    price: '₹65,000',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=800&h=600&fit=crop',
    rating: 4.6
  },
  {
    id: 8,
    title: 'Australia Highlights',
    destination: 'Australia',
    duration: '14 Days',
    route: 'Sydney • Melbourne • Great Barrier Reef • Uluru',
    price: '₹1,45,000',
    image: 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=800&h=600&fit=crop',
    rating: 4.8
  }
];

export const testimonials = [];

export const officeLocations = [
  {
    country: 'India',
    name: 'VK Tours - Retail Office',
    address: '1st Floor, Sai Plaza, Sanath Nagar, Above APCOB Bank, Kanuru, Vijayawada, Andhra Pradesh, India - 520007',
    phone: '+91 96188 49933',
    landline: '0866 4553285'
  },
  {
    country: 'USA',
    name: 'Bodacias Kalinga LLC',
    ein: 'EIN NO: 99-3378525',
    address: '200 S 21st ST STE 400A, Lincoln NE 68510'
  },
  {
    country: 'Maldives',
    name: 'VK TOURS MALDIVES PRIVATE LIMITED',
    registration: 'Registration No: C19022023',
    address: 'Maldives Office'
  }
];
